import type { TodaysActivitySession } from '@kinapp/shared';

const CATEGORY_COLORS: Record<string, string> = {
  SPORT: 'bg-green-100 text-green-700',
  MUSIC: 'bg-purple-100 text-purple-700',
  ACADEMIC: 'bg-blue-100 text-blue-700',
  SOCIAL: 'bg-pink-100 text-pink-700',
  MEDICAL: 'bg-red-100 text-red-700',
  TRANSPORT: 'bg-amber-100 text-amber-700',
  OTHER: 'bg-gray-100 text-gray-700',
};

interface ActivityCardProps {
  activities: TodaysActivitySession[];
}

export function ActivityCard({ activities }: ActivityCardProps) {
  if (activities.length === 0) {
    return (
      <div className="card">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">Today's Activities</h2>
        <p className="text-gray-500 text-sm">No activities scheduled today</p>
      </div>
    );
  }

  return (
    <div className="card">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Today's Activities</h2>
      <div className="space-y-3">
        {activities.map((session, i) => (
          <div key={`${session.activityId}-${i}`} className="p-3 rounded-lg border border-gray-200 bg-gray-50">
            <div className="flex items-start justify-between">
              <div>
                <div className="flex items-center gap-2">
                  <h3 className="font-medium text-gray-900">{session.activityName}</h3>
                  <span className={`text-xs px-1.5 py-0.5 rounded ${CATEGORY_COLORS[session.category] || CATEGORY_COLORS.OTHER}`}>
                    {session.category.toLowerCase()}
                  </span>
                </div>
                <div className="text-sm text-gray-600 mt-1">
                  {session.startTime} - {session.endTime}
                  {session.venue && <span className="ml-2">@ {session.venue}</span>}
                </div>
                {session.responsibleName && (
                  <div className="text-xs text-gray-500 mt-1">
                    {session.responsibleName}
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
